import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Web Components
import { applyPolyfills, defineCustomElements } from '@say-shared/web-components/dist/loader'

if (true || environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// Initialize the Web Components
applyPolyfills().then(() => {
  defineCustomElements(window)
})
